// extracted by mini-css-extract-plugin
module.exports = {"root":"login-page_root__2RmBc","title":"login-page_title__24Jv9","button":"login-page_button__2qyYu"};